const SET_ROLE = 'ymx/SET_ROLE';

export const initialState = {
    role: 'teacher',
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_ROLE:
        return Object.assign({}, state, {
            role: action.role
        });
    default:
        return state;
    }
};

const setRoleState = function (role) {
    return {
        type: SET_ROLE,
        role: role
    };
};



export {
    reducer as default,
    initialState as ymxInitialState,
    setRoleState,
};
